import { api_get, api_post, single_post, stringfy_post } from '@/utils/http'

const baseUrl = '/cguardian/api'

// 敏感词导入URL
const sensitiveWordUpload = baseUrl + '/sensitive/word/upload'
// 导出敏感词URL
const sensitiveWordDownload = baseUrl + '/sensitive/word/download'

// 查询敏感词
function sensitiveWordQuery(params: any) {
  return api_get(baseUrl + '/sensitive/word/query', params)
}

// 删除敏感词
function sensitiveWordDelete(params: any) {
  return api_post(baseUrl + '/sensitive/word/delete', params)
}

// 查询敏感图
function sensitivePicQuery(params: any) {
  return api_get(baseUrl + '/sensitive/pic/query', params)
}

// 修改图片样本
function sensitiveEditPic(params: any) {
  return stringfy_post(baseUrl + '/sensitive/pic/edit_pic', params)
}

// 删除图片样本
function sensitiveDelPic(params: any) {
  return api_post(baseUrl + '/sensitive/pic/del_pic', params)
}

// 拦截名单增加条目
function sensitiveAllowItem(params: { word_name: string | undefined }) {
  return single_post(baseUrl + '/sensitive/word/add-white', params)
}

// 黑名单通过
function sensitiveActive(params: { word_ids: string[] | number[] }) {
  return stringfy_post(baseUrl + '/sensitive/word/activate', params)
}

export {
  sensitiveWordQuery,
  sensitiveWordDelete,
  sensitiveWordDownload,
  sensitiveWordUpload,
  sensitivePicQuery,
  sensitiveEditPic,
  sensitiveDelPic,
  sensitiveAllowItem,
  sensitiveActive
}
